export enum DOCTOR_SLOT {
  FIRST_APPOINTMENT = 0,
  FOLLOW_UP_APPOINTMENT = 1,
}

export enum DOCTOR_SLOT_SUBTYPE {
  OFFLINE = 'offline',
  ONLINE = 'online',
}
